import React from "react";
import styles from './RadioButtonGroup.module.scss';
import RadioButton from "../radioButton/RadioButton";
import PropTypes from "prop-types";

const RadioButtonGroup = ({
  label,
  options,
  selected,
  onChange,
  error,
  disabled = false
}) => {

  return (
    <div className={styles.radioButtonGroup}>
      <label className={styles.label}>{label}</label>
      <div className={styles.radioButtons}>
        {options.map(option => <RadioButton
          key={option.value}
          label={option.label}
          checked={selected === option.value}
          onChange={() => onChange(option.value)}
          disabled={disabled}
        />)}
      </div>
      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
};

RadioButtonGroup.propTypes = {
  label: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  selected: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  disabled: PropTypes.bool
}

export default RadioButtonGroup;